export default [
  {
    id: 'per-person',
    name: '$ per person',
  },
  {
    id: 'total',
    name: '$ split between people',
  },
];
